import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { InvestorBalanceModel } from 'models';
import { formatNum } from 'utils';

import { Loader, Centered, Error } from 'components';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  investorBalance: InvestorBalanceModel;
  loading: boolean;
  error: boolean;
}

const BalanceAddonsDetails: React.FC<Props> = ({
  investorBalance,
  loading,
  error,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const renderBody = () => {
    return (
      <div>
        <h4 className={classes.addonTitle}>
          {t('#portal.investor.dashboard.balances')}
        </h4>
        <div>
          <div className={classes.cell}>
            <h5 className={classes.title}>
              {t('#portal.investor.dashboard.balances.overbalance')}
            </h5>
            <p className={classes.amount}>
              {formatNum(investorBalance.OverSaldo)} €
            </p>
          </div>
          <div className={classes.cell}>
            <h5 className={classes.title}>
              {t('#portal.investor.dashboard.balances.underbalance')}
            </h5>
            <p className={clsx(classes.amount, classes.amountRed)}>
              {formatNum(investorBalance.UnderSaldo)} €
            </p>
          </div>
        </div>

        <div className={classes.commentsSection}>
          <h5 className={classes.title}>
            {t('#portal.investor.dashboard.balances.comments')}
          </h5>
          {!!investorBalance.Comments && (
            <div className={classes.commentScroll}>
              <p className={classes.comment}>
                {investorBalance.ModifiedBy}
                <br />
                {investorBalance.Comments}
              </p>
            </div>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {error ? (
        <Centered>
          <Error />
        </Centered>
      ) : null}
      {loading ? (
        <Centered>
          <Loader size={30} themeColor="darkBlue" />
        </Centered>
      ) : null}
      {loading || error ? null : renderBody()}
    </>
  );
};

export default memo(BalanceAddonsDetails);
